import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { Close } from '@indeed/ifl-icons';
import { StyledNotificationBase, StyledNotificationBody, StyledNotificationIcon, StyledNotificationContent } from '../Alert/styles.js';
export { NotificationTitle as ToastTitle } from '../Alert/styles.js';
import { jsx } from '@emotion/react';
export { NOTIFICATION_TYPES as TOAST_TYPES } from '../Alert/types.js';
import { Button } from '../Button/Button.js';
import { icons } from '../Alert/Alert.js';
import { LiveRegion } from '../LiveRegion/LiveRegion.js';
import '../../utils/transition.js';
import 'focus-visible';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../IconWrapper/IconWrapper.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../VisuallyHidden/VisuallyHidden.js';

const statuses = {
  info: {
    borderColor: "background.status.info.weak",
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.info.weak"
    }
  },
  success: {
    borderColor: "background.status.success.weak",
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.success.weak"
    }
  },
  warning: {
    borderColor: "background.status.warning.weak",
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.warning.weak"
    }
  },
  critical: {
    borderColor: "background.status.critical.weak",
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.critical.weak"
    }
  }
};
const StyledToast = /*#__PURE__*/themed(StyledNotificationBase, process.env.NODE_ENV === "production" ? {
  styleProps: ["status"],
  shouldForwardProp: prop => prop !== "status",
  target: "e171e7gg0"
} : {
  styleProps: ["status"],
  shouldForwardProp: prop => prop !== "status",
  target: "e171e7gg0",
  label: "StyledToast"
})(_ref => {
  let {
    status = "info"
  } = _ref;
  return {
    display: "flex",
    alignItems: "flex-start",
    overflowWrap: "anywhere",
    columnGap: 2,
    paddingBlockStart: 3,
    paddingBlockEnd: 3,
    paddingInlineStart: 3,
    paddingInlineEnd: 3,
    inlineSize: "100%",
    maxInlineSize: "380px",
    color: "foreground.strong",
    bg: "background",
    borderInlineStartStyle: "solid",
    borderInlineStartWidth: "0.5rem",
    borderRadius: "md",
    boxShadow: "high",
    ...statuses[status],
    [`${StyledNotificationBody}`]: {
      flex: "1 1 auto",
      // Only the "body" of the toast should fill the available space.
      alignSelf: "center",
      paddingInlineStart: 2
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/toast
 */
const Toast = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    dismissProps = {
      "aria-label": "Close"
    },
    icon,
    onDismiss,
    status = "info",
    type = "polite",
    ...props
  } = _ref2;
  const Icon = icon === undefined ? icons[status] : icon;
  const AnnounceableContent = jsx(StyledNotificationContent, {
    sx: {
      paddingBlockStart: 0,
      paddingBlockEnd: 0
    }
  }, children);
  const ToastContent = type ? jsx(LiveRegion, {
    type: type
  }, AnnounceableContent) : AnnounceableContent;
  return jsx(StyledToast, _extends({
    ref: ref,
    status: status,
    role: "group"
  }, props), Icon && jsx(StyledNotificationIcon, {
    sx: {
      display: "flex",
      marginBlockStart: 0
    }
  }, Icon), jsx(StyledNotificationBody, null, ToastContent), onDismiss && jsx(Button, _extends({
    iconOnly: true,
    sx: {
      flex: "0 0 auto",
      marginBlockStart: -2,
      marginInlineEnd: -2,
      marginBlockEnd: -2
    },
    variant: "tertiary",
    size: "sm",
    onClick: onDismiss
  }, dismissProps), jsx(Close, {
    "aria-hidden": true
  })));
});
const TOAST_STATUSES = Object.keys(statuses);
Toast.displayName = "Toast";

export { TOAST_STATUSES, Toast };
